import { useState, useEffect } from 'react';

/**
 * Custom hook to detect mobile and provide optimized animation values
 */
export const useMobilePerformance = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Optimized values for mobile vs desktop
  const performanceConfig = {
    isMobile,
    // Reduce movement distance on mobile
    yOffset: isMobile ? 15 : 30,
    // Faster transitions on mobile to feel "snappier"
    duration: isMobile ? 0.4 : 0.8,
    // Reduce blur intensity for mobile GPUs
    blur: isMobile ? "blur(4px)" : "blur(12px)",
    // Viewport trigger margin
    viewportMargin: isMobile ? "-20px" : "-100px"
  };

  return performanceConfig;
};